import React from 'react'

export default function FighterPhone({ phone }) {
  return (
    <div className="flex flex-row items-center gap-1 pt-1">
      <div className="flex items-center">
        <svg
          id="whatsapp-icon"
          data-name="WhatsApp"
          xmlns="http://www.w3.org/2000/svg"
          version="1.1"
          viewBox="0 0 100 100"
          width={24}
          height={24}
        >
          <path
            className="cls-1"
            d="M66.2,55.8l-5.9-4.3c-.9-.7-2-.9-3.1-.8s-2.1.8-2.7,1.7l-1.8,2.5s0,0,0,0c-.3,0-1.8,0-5.3-2.8l-.4-.3c-3.7-2.5-4.1-3.9-4.2-4.2,0,0,0,0,0,0l1.8-2.5c1.3-1.8,1-4.5-.9-5.8l-6-4.4c-1.8-1.4-4.5-1-5.8.9l-1.9,2.5c-1.8,2.5-2.3,5.7-1.2,8.6,1.5,4.3,5.2,8.8,11,13.4,0,.1.2.2.3.3.1,0,.3.2.4.3.1.1.3.2.4.3.1,0,.3.2.4.2,6.2,4.1,11.6,6.3,16.1,6.4h.2c3,0,5.8-1.4,7.6-3.9l1.8-2.5c.7-.9.9-2,.8-3.1-.2-1.1-.8-2.1-1.6-2.7ZM63.9,59.3l-1.8,2.5c-1.1,1.5-2.8,2.3-4.4,2.2-2.7,0-7.4-1.2-14.7-6.2-7-5.4-9.5-9.5-10.4-12.1-.6-1.7-.3-3.6.7-5l1.8-2.5c0,0,.2,0,.2,0l6,4.4c0,0,0,.2,0,.2l-1.8,2.4c-.5.6-1,1.6-.9,2.8.2,2.3,2.1,4.7,5.9,7.2l.2.2c3.6,2.9,6.5,4,8.7,3.5,1.2-.3,2-1,2.4-1.7l1.8-2.4c0,0,.2,0,.2,0l5.9,4.3c0,0,0,.2,0,.2Z"
          />
          <path
            className="cls-1"
            d="M48.4,18c-18.1,0-32.9,14.8-32.9,32.9s2.6,15,7.5,20.9l-5.5,10.8c-.4.7-.3,1.6.2,2.2.4.5,1,.7,1.5.7s.4,0,.6,0l15.2-4.5c4.2,1.9,8.8,2.9,13.5,2.9,18.1,0,32.9-14.8,32.9-32.9s-14.8-32.9-32.9-32.9ZM48.4,79.8c-4.3,0-8.5-.9-12.4-2.8-.5-.2-1-.2-1.4-.1l-11.4,3.4,4-7.8c.4-.7.3-1.6-.3-2.2-4.8-5.3-7.4-12.2-7.4-19.3,0-15.9,13-28.9,28.9-28.9s28.9,13,28.9,28.9-12.9,28.9-28.9,28.9Z"
          />
        </svg>
      </div>
      <p className="text-sm">{phone ? `+${phone}` : 'N/D'}</p>
    </div>
  )
}
